export default __webpack_public_path__ + "static/media/logo_small_pantone.55068559.png";